<div
	class="slide slide--sentiment-over-time"
	[style.--slide-accent-color]="titleColor"
>
	<div class="slide__header">
		<div class="slide__content-copy">
			<typography variant="h/2" class="slide__title">
				<app-report-inline-text
					[text]="title"
					[field]="textFields.title"
					[editorMode]="editorMode"
				></app-report-inline-text>
			</typography>
			<div class="slide__date-row">
				<app-icon type="svg" [size]="14">calendar_today</app-icon>
				<typography variant="p/xs_regular" class="slide__date-text">
					{{ dateLabel }}
				</typography>
			</div>
			<typography variant="p/sm_regular" class="slide__summary">
				<app-report-inline-text
					[text]="summaryText"
					[field]="textFields.body"
					[editorMode]="editorMode"
				></app-report-inline-text>
			</typography>
		</div>
		<div class="slide__kpi-block" *ngIf="!isEmpty">
			<typography variant="h/1" class="slide__kpi-value">
				{{ positiveShare }}
			</typography>
			<div class="slide__kpi-label-row">
				<span
					class="slide__kpi-dot"
					[style.background]="kpiDotColor"
				></span>
				<typography variant="p/sm_regular" class="slide__kpi-label">
					Positive share
				</typography>
			</div>
		</div>
	</div>

	<div class="slide__body" *ngIf="chartData && !isEmpty">
		<div class="slide__chart-head">
			<typography variant="p/sm_medium" class="slide__chart-title">
				Sentiment evolution
			</typography>
			<div class="slide__legend">
				<div
					class="slide__legend-item"
					*ngFor="let chip of legendChips; trackBy: trackByChipId"
				>
					<span
						class="slide__legend-swatch"
						[style.background]="chip.color"
					></span>
					<typography
						variant="p/sm_regular"
						class="slide__legend-label"
					>
						{{ chip.label }}
					</typography>
				</div>
			</div>
		</div>
		<div class="slide__chart slide__chart-host">
			<canvas
				*ngIf="!chartSwitch.block"
				baseChart
				[data]="chartData"
				[options]="chartOptions"
				[type]="chartType"
			></canvas>
			<app-report-chart-switch
				[state]="chartSwitch"
				[themeColor]="themeColor"
				[editorMode]="editorMode"
				(chartTypeChange)="chartTypeChange.emit($event)"
			></app-report-chart-switch>
		</div>
	</div>

	<app-slide-no-data *ngIf="isEmpty"></app-slide-no-data>
	<div class="slide__footer">
		<app-report-slide-brand class="slide__footer-left">
			<typography variant="p/xxs_regular" class="slide__footer-copy">
				Powered by
			</typography>
			<typography variant="p/xxs_semibold" class="slide__footer-brand">
				lolly
			</typography>
		</app-report-slide-brand>
		<div class="slide__footer-tag">sentiment over time</div>
	</div>
</div>
